import AuthenticatedAPIClient from '../lib/AuthenticatedAPIClient';
import { URL } from '../helpers/DelayRepayEndpoint';
import APIClient from '../lib/APIClient';

const DelayRepayService = {
    async subscribe (user, notifyByPreference) {
        try {
            const response = await AuthenticatedAPIClient.put(URL.subscribe.replace('{id}', user.id), {
                customerId: user.id,
                emailOptedIn: notifyByPreference === 'email' || notifyByPreference === 'appAndEmail',
                appOptedIn: notifyByPreference === 'app' || notifyByPreference === 'appAndEmail'
            });
            return response;
        } catch (e) {
            console.warn('error calling OCDR subscribe service', e);
            return false;
        }
    },

    async unsubscribe (customerId) {
        try {
            const response = await AuthenticatedAPIClient.delete(URL.subscribe.replace('{id}', customerId), {
                customerId,
            });
            return response;
        } catch (e) {
            console.warn('error calling OCDR unsubscribe service', e);
            return false;
        }
    },

    async getCharities () {
        try {
            return await APIClient.get('/delay-repay/charity');
        } catch (error) {
            return [];
        }
    }
};

export default DelayRepayService;



// WEBPACK FOOTER //
// ./src/services/DelayRepayService.js